module.exports = __webpack_public_path__ + "static/ibotta_landing-5769ef96d07e6dbc2048f1d6a0dd2268.png";